import { createBrowserRouter, Navigate } from 'react-router-dom';
import { homeRoutePath, loginRoutePath } from 'core/constants/routes.constants';
import { ProtectedLayout } from 'shared/components/main-components/protected-layout';
import RouteGuard from 'shared/components/main-components/route-guard/route-guard';
import { getRoutesFromMenuRoutes, protectedRoutes } from 'shared/utils/routes/route.utils';
import NotFound from './not-found';

export const appRoutes = createBrowserRouter([
  {
    path: loginRoutePath,
    async lazy() {
      const module = await import('screens/login');
      return { Component: module.default };
    },
  },
  {
    path: '/',
    element: <ProtectedLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={homeRoutePath} replace />,
      },
      {
        element: <RouteGuard />,
        children: getRoutesFromMenuRoutes(protectedRoutes),
      },
      {
        path: '/not-found',
        element: <NotFound />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);
